// extracted by mini-css-extract-plugin
export default {"mainTitle":"Clients_mainTitle__VnyLV","clients":"Clients_clients__22DCG","clientContainer":"Clients_clientContainer__LXpL8","client":"Clients_client__O-35A"};